/*
*   产品信息组件
*   zxw
*   2024-10-31
*/

import React , { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { Row, Col, message, Modal, Button,} from 'antd';
import { UjoinParams, AddRequestHeaders, Html2pdf} from '../../incs/FunHelper.js';


import XZTLOGO from '../../images/logo_head.png';
import PAGEHEADERRIGHT from '../../images/page-header-right.png';
const ProductInfo = (props) => {
    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);
    const handleCancel = () => {setOpen(false);};
    const printer = () => { 
        var printContents = document.getElementById('product-info-id').innerHTML;
        var originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload();
    };
    const download = () => { Html2pdf('print-info-id', data?data.number:'','');};

    useEffect(() => {
        setOpen(props.open)
    }, [props]);

    useEffect(() => {
        //  调用接口，获取产品信息
        const params = {
            'number': props.number,
        };
        $.ajax({
            url: `${CNF.scmsApi}products${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    if(data.dat.length > 0){
                        setData(data.dat[0]);
                    }else{
                        message.info('产品信息未找到', 1.5);
                    }
                }else{
                    message.error(data.msg, 1.5);
                }
            }
        })
    }, [props.number]);
    return (
        <>
            <Modal 
                width={820}
                style={{ top: 0}}
                closable={false}
                open={open}
                keyboard={true}
                maskClosable={true}
                onCancel={handleCancel}
                footer={[
                    <Button key='back' onClick={handleCancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download}>下载</Button>,
                ]}
            >
                <div id='print-info-id'>
                    <div className='print-info' style={{ padding: '0 30px' }}>
                        <Row style={{ margin: '10px' }}>
                            <Col span={2}><img src={XZTLOGO} height='45px' alt={'新致腾'} /></Col>
                            {
                                <Col span={22} align='right'><img src={PAGEHEADERRIGHT} height='35px' alt='新致腾' /></Col>
                            }
                        </Row>
                        <table width='100%'>
                                <thead align='center'>
                                    <tr>
                                        <th colSpan='24'><h2>产品信息表</h2></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>产品编码:</td><td colSpan='8' style={{ width: 220 }}>{data?data.number:''}</td>
                                        <td colSpan='3' style={{ width: 140 }}>供应商编码:</td><td colSpan='8' style={{ width: 240 }}>{data?data.supplier_number:''}</td>
                                    </tr>
                                    <tr><td colSpan='5' style={{ width: 120 }}>产品名称:</td><td colSpan='19' style={{ width: 600 }}>{data?data.name:''}</td></tr>
                                    <tr><td colSpan='5' style={{ width: 120 }}>供应商名称:</td><td colSpan='19' style={{ width: 600 }}>{data?data.supplier_name:''}</td></tr>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>单位:</td><td colSpan='8' style={{ width: 220 }}>{data?data.unit:''}</td>
                                        <td colSpan='3' style={{ width: 140 }}>单价（元）:</td><td colSpan='8' style={{ width: 240 }}>{data?data.price:''}</td>
                                    </tr>
                                    <tr><td colSpan='5' style={{ width: 120 }}>品牌:</td><td colSpan='19' style={{ width: 600 }}>{data?data.brand:''}</td></tr>
                                    <tr><td colSpan='5' style={{ width: 120 }}>产品型号:</td><td colSpan='19' style={{ width: 600 }}>{data?data.model:''}</td></tr>
                                    <tr>
                                        <td colSpan='5' style={{ width: 120 }}>物料编码:</td><td colSpan='8' style={{ width: 220 }}>{data?data.material_code:''}</td>
                                        <td colSpan='3' style={{ width: 140 }}>条形码:</td><td colSpan='8' style={{ width: 240 }}>{data?data.bar_code:''}</td>
                                    </tr>
                                    <tr><td colSpan='5' style={{ width: 120 }}>产品描述:</td><td colSpan='19' style={{ width: 600 }}>
                                        {data&&data.description&&data.description.split('\n').map((item)=>{
                                            return <p style={{ margin: 0 }}>{item}</p>;
                                        })}
                                    </td></tr>
                                </tbody>
                            </table>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default ProductInfo